import * as React from 'react';
import { Icon } from 'antd';
import { Route } from 'kts-platform-frame/routes';

const parentName: string = '/workbench/platform/network'; // 路由的跟节点；

Route.addNode(
    parentName, 
    { nodeName: '/workbench/platform/network-chat-verification', path: '*/network/userlist/chatVerification/:companyId/:toCompanyId', ico: <Icon type="user" />, title: '会话跳转验证', component: require('./UI.Chat.Verification').default },
    { nodeName: '/workbench/platform/network-company-detail',  path: '*/network/userlist/companyDetail/:id', ico: <Icon type="user" />, title: '公司详情', component: require('./UI.Network.User.List.Detail').default },
    { nodeName: '/workbench/platform/network-user-list', path: '*/network/userlist', ico: <Icon type="user" />, title: '我的网络', component: require('./UI.Network.User.List').default },
    { nodeName: '/workbench/platform/network-admin-list', path: '*/network/admin', ico: <Icon type="team" />, title: '网络管理', component: require('./UI.Network.Admin').default },
);

export default {
    getChildReact: (index?: string) => {
        return Route.getChildReact(parentName, index);
    },
    getNodeReact: (nodename: string) => {
        return Route.getNode(nodename);
    }
};

export {
    Switch
} from 'react-router-dom';



// WEBPACK FOOTER //
// ./src/display/platform/Network/Modules.Route.tsx